import React, { useState } from 'react';
import { useMasterSubjectsSelector } from '../../../../redux/selector';
import { mapToSelectItems } from '../../../../utils/utils';
import { Button, Input, message, Select } from 'antd';
import { generateQuestionCodes } from '../../../../service/autoCodeService';
import processError from '../../../../utils/processError';

function QuestionAutoCode() {
  const subjects = useMasterSubjectsSelector();
  const [subjectId, setSubjectId] = useState<string | null>(null);
  const [questionCodes, setQuestionCodes] = useState<string[]>([]);
  const [numberOfCodes, setNumberOfCodes] = useState('');
  const [fetchingCode, setFetchingCode] = useState(false);

  async function handleGetNewCode() {
    if (!subjectId) {
      message.error('Vui lòng chọn môn học');
      return;
    }
    const selectedSubject = subjects.find((subject) => subject.id === subjectId);
    if (!selectedSubject) {
      message.error('Môn học không hợp lệ');
      return;
    }
    try {
      setQuestionCodes([]);
      setFetchingCode(true);
      const newQuestionCodes = await generateQuestionCodes(
        selectedSubject.code,
        numberOfCodes ? parseInt(numberOfCodes) : null,
      );
      setQuestionCodes(newQuestionCodes);
      message.info('Lấy mã câu hỏi thành công');
    } catch (err) {
      processError(err);
    } finally {
      setFetchingCode(false);
    }
  }

  return (
    <div className={'w-full h-[calc(100vh-112px)] p-8 overflow-y-auto bg-white flex flex-col'}>
      <div className={'w-full flex flex-col gap-y-4'}>
        <div className="text-left text-[18px] font-medium">Chọn môn học</div>
        <Select
          placeholder={'Môn học'}
          className={'ml-0 w-[300px] text-left'}
          value={subjectId}
          onChange={setSubjectId}
          options={[...mapToSelectItems(subjects)]}
        />
        <div className="text-left text-[18px] font-medium">Số lượng mã (mặc định 1 nếu để trống)</div>
        <Input
          className={'ml-0 w-[300px]'}
          value={numberOfCodes}
          type={'number'}
          onChange={(e) => setNumberOfCodes(e.target.value)}
          placeholder={'Số lượng mã'}
        />
        <Button className={'w-fit'} type={'primary'} size={'large'} onClick={handleGetNewCode} loading={fetchingCode}>
          Lấy mã mới
        </Button>
        <div className={'flex flex-col gap-y-2 items-start'}>
          {questionCodes.map((questionCode) => (
            <div className={'font-bold'} key={questionCode}>
              {questionCode}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default QuestionAutoCode;
